import React from 'react';

class ModalPopUp extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    executeScript() {
        const { script } = this.props;
        
        if(script && window.myGlobalCounter==0)
        {
            window.myGlobalCounter=1;
            eval(script);
        }
      }

    render() {
        const { isModalOpen, onSubmit, onCancel, body, secondContent, title, cancelButton, submitButton, className, image } = this.props;
        return (
            <>
                {isModalOpen && <div className="modalxx flex items-center">
                <div className="m-auto body-content-width">
                    <div className={"activity-popup text-center " + className}>
                        {image && <div className="row text-center m-t-50 m-b-50">
                            <div className="col text-center">
                                <p>
                                    <img src={image} alt="images" />
                                </p>
                            </div>
                        </div>}
                        <h1 className="h-title uppercase mb-4">{title}</h1>
                        <p className="p-content">{body}</p>
                        {this.executeScript()}
                        {secondContent && <p className="p-content">{secondContent}</p>}
                        <div className="mt-4">
                            
                                {cancelButton ? 
                                    <button className="btn bbtn text-xs mr-2 leading-relaxed" onClick={() => onCancel()}>{cancelButton}</button>
                                    : null}
                                {submitButton ? 
                                    <button className="btn bbtn text-xs leading-relaxed" onClick={() => onSubmit()}>{submitButton}</button>
                                    : null}
                            
                        </div>
                    </div>
                </div>
                </div>}
            </>
        );
    }
}

export default ModalPopUp